

























































































import { Component, Mixins } from 'vue-property-decorator';
import { PersonalInfoModel } from '@/interfaces/registration/models/PersonalInfoModel';
import { ListOption } from '@/interfaces/registration/ListOption';
import RegistrationPanelMixing from '@/mixins/registration/RegistrationPanelMixin';
import FieldMixin from '@/mixins/registration/FieldMixin';
import { namespace } from 'vuex-class';
const utils = namespace('utils');

  @Component
export default class PersonalInfoPanel extends Mixins(RegistrationPanelMixing, FieldMixin) {
    public model: PersonalInfoModel = {};

    @utils.State
    public genders!: Array<ListOption>;

    mounted () {
      this.$data.model = this.getPanelData('personalInfo');

      window.scrollTo(0, 0);
    }

    public savePanelData (): Promise<boolean> {
      this.saveRegistrationModel({ data: this.model, model: 'personalInfo' });
      return Promise.resolve(true);
    }

    get hasAttendeeTerms (): boolean {
      return !this.registrationData.registration?.agreedToAttendeeTerms &&
        this.registrationData.eventPreferences?.attendeeTerms !== undefined &&
        this.registrationData.eventPreferences?.attendeeTerms !== null &&
        this.registrationData.eventPreferences?.attendeeTerms !== '';
    }

    public attendeeTermsLabel (): string {
      return 'I agree to the <a href="#" data-toggle="modal" data-target="#attendeeTermsModal">attendee terms and conditions</a> for this event';
    }

    get showAgreeToTerms (): boolean {
      return !this.registrationData.accountCreationRequired && (this.registrationData.user == null || this.registrationData.user.id == null || this.registrationData.user.id === 0);
    }
}
